import { GetVisitById } from 'woofwoof-api';

/**
 * A visit read by id, for surfaces that were handed a list row.
 *
 * The list endpoints format visits with `includeDraftFlag` — which sets
 * `hasNotesDraft` but deliberately leaves `notesDraft` undefined, so a page of
 * visits doesn't ship every unsent draft's text. `GET /api/visit/:visitId`
 * passes `includeDraftNotes` for the owning organisation instead, so the draft
 * itself only arrives through this query. Shared by the calendar modal and the
 * live visit page so both read one cache entry per visit.
 */
export const visitDetailsKey = (visitId?: string): unknown[] => [
  'visit-details',
  visitId,
];

/**
 * Which visit to render: the freshly-fetched one when it is available,
 * otherwise the row we already had so there is something to show while the
 * fetch is in flight.
 *
 * The id check is load-bearing. Moving from one visit to another leaves the
 * previous fetch cached or in flight for a moment, and rendering visit B's row
 * against visit A's detail would show one patient's notes under another
 * patient's name.
 */
export function resolveVisitDetails(
  fromList?: GetVisitById,
  fetched?: GetVisitById,
): GetVisitById | undefined {
  if (!fromList) return fetched;
  if (!fetched) return fromList;
  return fetched.id === fromList.id ? fetched : fromList;
}
